import { Navigate } from "react-router-dom";
import { useAuth } from "../auth/useAuth";

export function LoginScreen() {
  const { access, error, resetAuthAttempt, signInWithGoogle, status } =
    useAuth();

  /*
   * Authentication/bootstrap transitions are intentionally silent.
   * Internal session, profile and authorization checks must never
   * become user-facing progress screens.
   */
  if (
    status === "unknown" ||
    status === "checking" ||
    status === "oauth_redirecting"
  ) {
    return null;
  }

  if (access.status === "authorized") {
    return <Navigate to="/command-center" replace />;
  }

  const publicState =
    access.status === "denied"
      ? "Access denied"
      : error
        ? "Unable to sign in"
        : null;

  return (
    <main className="login-shell">
      <section className="login-card public-login-card" aria-live="polite">
        {publicState ? (
          <>
            <h1>{publicState}</h1>

            {access.status !== "denied" ? (
              <button
                className="primary-action"
                type="button"
                onClick={() => {
                  resetAuthAttempt();
                  void signInWithGoogle();
                }}
              >
                Continue with Google
              </button>
            ) : null}
          </>
        ) : (
          <>
            <p className="brand-label">CYAN</p>
            <h1>Sign in to SS</h1>

            <button
              className="primary-action"
              type="button"
              onClick={() => void signInWithGoogle()}
            >
              Continue with Google
            </button>
          </>
        )}
      </section>
    </main>
  );
}
